import { DragDropModule } from '@angular/cdk/drag-drop';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { PopoverModule } from 'ngx-smart-popover';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import {
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor } from './helpers';
import { DefaultLayoutComponent } from './layouts/default/default.component';
import { LandingSiteLayoutComponent } from './layouts/landing-site/landing-site.component';
import { OutsideTheGateLayoutComponent } from './layouts/outside-the-gate/outside-the-gate.component';
import { SharedService } from './layouts/shared-service';
import { NiComponentsModule } from './ni-components/ni-components.module';
import { PagesModule } from './pages/pages.module';
// Services
import { AcukwikairportsService } from './services/acukwikairports.service';
import { AircraftpricesService } from './services/aircraftprices.service';
import { AircraftsService } from './services/aircrafts.service';
import { AirportWatchService } from './services/airportwatch.service';
import { AppService } from './services/app.service';
import { ContactinfobyfboService } from './services/contactinfobyfbo.service';
import { ContactinfobygroupsService } from './services/contactinfobygroups.service';
import { ContactsService } from './services/contacts.service';
import { CustomcustomertypesService } from './services/customcustomertypes.service';
import { CustomerCompanyTypesService } from './services/customer-company-types.service';
import { CustomeraircraftsService } from './services/customeraircrafts.service';
import { CustomercontactsService } from './services/customercontacts.service';
import { CustomerinfobygroupService } from './services/customerinfobygroup.service';
import { CustomermarginsService } from './services/customermargins.service';
import { CustomersService } from './services/customers.service';
import { CustomersviewedbyfboService } from './services/customersviewedbyfbo.service';
import { DistributionService } from './services/distribution.service';
import { EmailcontentService } from './services/emailcontent.service';
import { FboairportsService } from './services/fboairports.service';
import { FbocontactsService } from './services/fbocontacts.service';
import { FbofeeandtaxomitsbycustomerService } from './services/fbofeeandtaxomitsbycustomer.service';
import { FbofeeandtaxomitsbypricingtemplateService } from './services/fbofeeandtaxomitsbypricingtemplate.service';
import { FbofeesandtaxesService } from './services/fbofeesandtaxes.service';
import { FbomissedquoteslogService } from './services/fbomissedquoteslog.service';
import { FbopreferencesService } from './services/fbopreferences.service';
import { FbopricesService } from './services/fboprices.service';
import { FbosService } from './services/fbos.service';
import { FuelreqsService } from './services/fuelreqs.service';
import { GroupsService } from './services/groups.service';
import { LandingsiteService } from './services/landingsite.service';
import { Parametri } from './services/paremeters.service';
import { PricetiersService } from './services/pricetiers.service';
import { PricingtemplatesService } from './services/pricingtemplates.service';
import { RampfeesService } from './services/rampfees.service';
import { RampfeesettingsService } from './services/rampfeesettings.service';
import { TemporaryAddOnMarginService } from './services/temporaryaddonmargin.service';
import { UserService } from './services/user.service';
import { LoginModalComponent } from './shared/components/login-modal/login-modal.component';
import { RequestDemoModalComponent } from './shared/components/request-demo-modal/request-demo-modal.component';
import { RequestDemoSuccessComponent } from './shared/components/request-demo-success/request-demo-success.component';
import { metaReducers, reducers } from './store/reducers';
import { UIModule } from './ui/ui.module';
import { TagsService } from './services/tags.service';
import { AssociationsService } from './services/associations.service';
import { AirportFboGeofenceClustersService } from './services/airportfbogeofenceclusters.service';
import { AirportFboGeofenceClusterCoordinatesService } from './services/airportfbogeofenceclustercoordinates.service';
import { DateTimeService } from './services/datetime.service';
import { SwimService } from './services/swim.service';
import { FlightWatchService } from './services/flightwatch.service';
import { FlightWatchHelper } from './pages/flight-watch/FlightWatchHelper.service';
import { PublicViewComponent } from './layouts/public-view/public-view.component';
import { FileHelper } from './helpers/files/file.helper';
import { PricingTemplateCalcService } from './pages/pricing-templates/pricingTemplateCalc.service';
import { DocumentService } from './services/documents.service';
import { ServiceOrderService } from './services/serviceorder.service';
import { ServicesAndFeesService } from './services/servicesandfees.service';
import { ServiceTypeService } from './services/servicetypes.service';
import { SnackBarService } from './ui-services/snackbar/snackBar.service';
import { FavoritesService } from './services/favorites.service';
import { FormValidationHelperService } from './helpers/forms/formValidationHelper.service';
import { FlightWatchMapSharedService } from './pages/flight-watch/services/flight-watch-map-shared.service';
import { ManageFboGroupsService } from './services/managefbo.service';
import { StringHelperService } from './helpers/strings/stringHelper.service';
import {JetNetService} from './services/jetnet.service';
import {Aero1200Service } from './services/1200aero/aero1200.service';
import { MapAllowedIcaosService } from './services/map-allowed-icaos.service';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { AuthenticationService } from './services/security/authentication.service';
import { FboUiService } from './ui-services/fbos/fbo-ui.service';
import { FboBusinessService } from './business/fbo/fbo-business.service';
import { MaterialLegacyModule } from './material-legacy.module';
import { MaterialMdcModule } from './material-mdc.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AppDialogWrapperComponent } from './ni-components/app-dialog-wrapper/app-dialog-wrapper.component';
@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        DefaultLayoutComponent,
        PublicViewComponent,
        LandingSiteLayoutComponent,
        OutsideTheGateLayoutComponent,
        LoginModalComponent,
        RequestDemoModalComponent,
        RequestDemoSuccessComponent,
        AppDialogWrapperComponent,
    ],
    imports: [
        MaterialLegacyModule,
        MaterialMdcModule,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        DragDropModule,
        ReactiveFormsModule,
        NgxUiLoaderModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        EffectsModule.forRoot([]),
        StoreModule.forRoot(reducers, {
            metaReducers,
        }),
        StoreDevtoolsModule.instrument({
            logOnly: environment.production,
            maxAge: 25,
        }),
        AppRoutingModule,
        UIModule,
        NiComponentsModule,
        PagesModule,
        PopoverModule,
    ],
    exports: [
        AppDialogWrapperComponent,
    ],
    providers: [
        {
            multi: true,
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
        },
        {
            multi: true,
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
        },
        AcukwikairportsService,
        AircraftsService,
        AircraftpricesService,
        AuthenticationService,
        ContactinfobyfboService,
        ContactinfobygroupsService,
        ContactsService,
        CustomcustomertypesService,
        CustomeraircraftsService,
        CustomerCompanyTypesService,
        CustomercontactsService,
        CustomerinfobygroupService,
        CustomermarginsService,
        CustomersService,
        CustomersviewedbyfboService,
        DistributionService,
        EmailcontentService,
        FboairportsService,
        FbocontactsService,
        FbofeesandtaxesService,
        FbofeeandtaxomitsbycustomerService,
        FbofeeandtaxomitsbypricingtemplateService,
        FbomissedquoteslogService,
        FbopreferencesService,
        FbopricesService,
        FbosService,
        FuelreqsService,
        GroupsService,
        LandingsiteService,
        Parametri,
        PricetiersService,
        PricingtemplatesService,
        RampfeesService,
        RampfeesettingsService,
        SharedService,
        TemporaryAddOnMarginService,
        UserService,
        AppService,
        AirportWatchService,
        TagsService,
        AssociationsService,
        AirportFboGeofenceClustersService,
        AirportFboGeofenceClusterCoordinatesService,
        DateTimeService,
        SwimService,
        FlightWatchService,
        FlightWatchHelper,
        FileHelper,
        PricingTemplateCalcService,
        DocumentService,
        ServiceOrderService,
        ServicesAndFeesService,
        ServiceTypeService,
        SnackBarService,
        FavoritesService,
        FormValidationHelperService,
        FlightWatchMapSharedService,
        ManageFboGroupsService,
        StringHelperService,
        JetNetService,
        FboUiService,
        FboBusinessService,
        MapAllowedIcaosService
    ],
})
export class AppModule { }
